var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderRhsIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_665)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.266113,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#26DDF9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_458_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8161 27.5331L25.9785 3.54772L1.99314 4.38531L2.83072 28.3707L26.8161 27.5331Z",
    fill: "#FB1855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.376 21.9988L9.13379 26.8247L13.9597 3.31491L-9.55015 -1.51096L-14.376 21.9988Z",
    fill: "#F2AA02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4967 13.2313L44.2622 -10.0659L20.965 -15.8313L15.1995 7.46586L38.4967 13.2313Z",
    fill: "#188FF2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_665"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.266113,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_458_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.266113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderRhsIcon2);
export default __webpack_public_path__ + "static/media/header_rhs_icon_2.b381bdc23e06873e4f40ea99dd19c9b1.svg";
export { ForwardRef as ReactComponent };